module.exports = __webpack_public_path__ + "img/empty.04cd1d27.png";